// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPriceSummaryResponse

import { hydrateWidgetBookingPriceBase, type WidgetBookingPriceBase, type WidgetBookingPriceBaseApiResponse } from './widgetBookingPriceBase.gen';
import { hydrateWidgetBookingPriceGuest, type WidgetBookingPriceGuest, type WidgetBookingPriceGuestApiResponse } from './widgetBookingPriceGuest.gen';
import { hydrateWidgetBookingPriceProduct, type WidgetBookingPriceProduct, type WidgetBookingPriceProductApiResponse } from './widgetBookingPriceProduct.gen';
import { hydrateWidgetBookingPricePackageUsage, type WidgetBookingPricePackageUsage, type WidgetBookingPricePackageUsageApiResponse } from './widgetBookingPricePackageUsage.gen';
import { hydrateWidgetBookingPriceDiscount, type WidgetBookingPriceDiscount, type WidgetBookingPriceDiscountApiResponse } from './widgetBookingPriceDiscount.gen';

export type WidgetBookingPriceSummaryApiResponse = {
	total: number;
	basePrices: WidgetBookingPriceBaseApiResponse[];
	guestPrices: WidgetBookingPriceGuestApiResponse[];
	products: WidgetBookingPriceProductApiResponse[];
	packageUsages: WidgetBookingPricePackageUsageApiResponse[];
	discount: WidgetBookingPriceDiscountApiResponse | null;
};

export type WidgetBookingPriceSummary = {
	total: number;
	basePrices: WidgetBookingPriceBase[];
	guestPrices: WidgetBookingPriceGuest[];
	products: WidgetBookingPriceProduct[];
	packageUsages: WidgetBookingPricePackageUsage[];
	discount: WidgetBookingPriceDiscount | null;
};

export function hydrateWidgetBookingPriceSummary(data: WidgetBookingPriceSummaryApiResponse): WidgetBookingPriceSummary {
	return {
		...data,
		basePrices: data.basePrices.map(hydrateWidgetBookingPriceBase),
		guestPrices: data.guestPrices.map(hydrateWidgetBookingPriceGuest),
		products: data.products.map(hydrateWidgetBookingPriceProduct),
		packageUsages: data.packageUsages.map(hydrateWidgetBookingPricePackageUsage),
		discount: data.discount ? hydrateWidgetBookingPriceDiscount(data.discount) : null,
	};
}